export default __webpack_public_path__ + "a88dc69fffd7faf27abe0c9f91a49995.png";